import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  mainNavigationWrapper: {
    [theme.breakpoints.up(theme.customBreakpoints.mdl)]: {
      position: 'fixed',
      left: 0,
      height: 'calc(100vh - 64px)',
      overflowY: 'auto',
      width: theme.typography.pxToRem(296),
      padding: theme.spacing(7, 2.5),
      background: theme.palette.primary.main,
      display: 'flex',
      justifyContent: 'flex-start'
    }
  },
  navCollapseList: {},
  mainNavigation: {
    width: '100%',
    '& ul': {
      listStyle: 'none',
      margin: theme.spacing(0),
      padding: theme.spacing(0),
      '&$navCollapseList': {
        paddingLeft: theme.spacing(1.5)
      }
    },
    '& a, & button': {
      color: theme.palette.common.white + '!important',
      padding: theme.spacing(2, 2.5),
      marginBottom: theme.spacing(1),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      wordBreak: 'break-word',
      width: `calc(100% + ${theme.spacing(2.5)}px)`,
      borderTopLeftRadius: theme.spacing(3),
      borderBottomLeftRadius: theme.spacing(3),
      fontSize: theme.typography.pxToRem(16),
      fontWeight: theme.typography.fontWeightRegular,
      textTransform: 'capitalize',
      textDecoration: 'none',
      lineHeight: 1.36,
      position: 'relative',
      [theme.breakpoints.down(theme.customBreakpoints.mdl)]: {
        color: theme.palette.common.white
      },
      '& svg': {
        fontSize: theme.typography.pxToRem(30)
      },
      '& span': {
        lineHeight: 1.3,
        verticalAlign: 'middle'
      },
      '&:hover, &:focus, &.active': {
        background: theme.palette.common.white,
        color: theme.palette.primary.main + '!important',
        '& $navigatorWrapper': {
          marginRight: `-${theme.spacing(1.5)}px`
        },
        [theme.breakpoints.down(theme.customBreakpoints.mdl)]: {
          color: theme.palette.text.primary
        }
      }
      // '&:hover, &:focus': {
      //   color: theme.palette.secondary.main,
      //   [theme.breakpoints.down(theme.customBreakpoints.mdl)]: {
      //     color: theme.palette.text.primary
      //   }
      // }
    }
  },
  menuTextWrapper: {
    display: 'flex',
    alignItems: 'center',
    fontSize: theme.typography.pxToRem(18)
  },
  iconWrapper: {
    marginRight: theme.spacing(2.5)
  },
  navigatorWrapper: {
    color: theme.palette.primary.main,
    transition: 'all 0.5s ease-in-out'
  },
  navCollapseBtn: {
    '& .MuiButton-label': {
      display: 'flex',
      alignItems: 'center',
      paddingRight: 0,
      lineHeight: 1.36,
      '& > div': {
        flex: '1 1 auto',
        display: 'flex',
        alignItems: 'center'
      }
    },
    '&:hover, &:focus': {
      backgroundColor: 'transparent'
    }
  }
}))
